import React, { useEffect, useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import { baseUrl } from "../../../services/config";
import { useState } from "react";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import { DatePicker, Image, Space, Switch, Tag } from "antd";
import { Button, Modal, Spinner, Table } from "react-bootstrap";
import usePagination from "../../components/usePagination/usePagination";
import UsePagination from "../../components/UsePagination";
import ApproveReject from "../../components/ApproveReject/ApproveReject";
import toast from "react-hot-toast";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import Form from "react-bootstrap/Form";

import SVG from "react-inlinesvg";

const { RangePicker } = DatePicker;

const { ExportCSVButton } = CSVExport;

const BugsReports = () => {
  const initialFilter = {
    pageNumber: 1,
    pageSize: 10,
  };

  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [statusModal, setStatusModal] = useState(false);
  const [statusModal2, setStatusModal2] = useState(false);
      const [deleteLoading, setdeleteLoading] = useState(false)
  
  const [statusValue, setStatusValue] = useState("");
  const updatingQueryParams = (page) => {
    console.log(page);
    setQueryParamsBase({
      pageNumber: page,
    });
  };

  const onPaginationSelectChange = () => {
    setQueryParamsBase({
      pageNumber: 1,
    });
  };

  const authToken = localStorage.getItem("userToken");

  const [loading, setLoading] = useState(false);
  const [rewardsList, setRewardList] = useState([]);
  const [links, setlinks] = useState([]);
  const [numberofpages, setnumberofpages] = useState(0);
  const [total, settotal] = useState(0);
  const [dateChangeData, setDateChangeData] = useState([]);
  const [date, setDate] = useState([]);
  const [csvList, setCsvList] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [updateSlots, setUpdateSlots] = useState(false);
  const [prevUrl, setPrevUrl] = useState();
      const [show2, setShow2] = useState(false);
      const handleClose2 = () => setShow2(false);
  const getHistory = (url) => {
    setPrevUrl(url);
    setLoading(true);
    setDateChangeData([]);
    fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          setRewardList(data.payload);
          // setnumberofpages(data.payload.per_page);
          // settotal(data.payload.total);
          // setlinks(data.payload.links)
          setLoading(false);
        } else {
          setLoading(false);

          setRewardList([]);
        }
      })
      .catch((err) => {
        setLoading(false);

        console.log(err);
      });
  };

  const handleShow2 = id => {
    setSelectedId(id)
    setShow2(true)
};


const deleteCode = () => {
  setdeleteLoading(true)
  fetch(`${baseUrl}/admin/delete-report-bugs/${selectedId}`, {
      method: "DELETE",
      headers: {
          Authorization: `Bearer ${authToken}`,
      }
  }).then(res => res.json())
      .then((data) => {
          console.log(data);
          if (data.metadata.success) {
              handleClose2()
              getHistory(`${baseUrl}/admin/report-bugs`);
              setdeleteLoading(false)
              toast.success(data.metadata.message);
              // setPromocodesList(data.payload);

          }
      })
      .catch(err => {
          console.error("codes error", err)
          setdeleteLoading(false)
      });
}

  useEffect(() => {
    getHistory(`${baseUrl}/admin/report-bugs`);
  }, []);

  const onPaginate = (link) => {
    getHistory(link?.url);
  };

  let [page, setPage] = useState(1);
  const PER_PAGE = 10;

  const count = Math.ceil(dateChangeData.length / PER_PAGE);
  const _DATA = usePagination(dateChangeData, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  const getClassOrder = (row) => {
    let classname = "";
    if (row == "Reported") {
      classname = "#fa0";
    } else if (row == "Resolved") {
      classname = "#87d068";
    } else {
        classname = "#2db7f5";
    }

    return classname;
  };

  console.log("csvArray", csvList);
  function capitalizeFirstLetter(string) {
    if (!string) return ""; // Handle empty or undefined strings
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  const callBack = () => {
    getHistory(prevUrl);
  };
  function removePaidRequest(input) {
    if (input) {
      return input.replace("Paid Request", "").trim();
    }
  }

  const changeStatus = () => {
    setdeleteLoading(true);

    fetch(`${baseUrl}/admin/report-bug-toggle/${selectedId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.metadata.success) {
          getHistory(`${baseUrl}/admin/report-bugs`);
          setSelectedId(null);
          setdeleteLoading(false);
          setStatusModal(false);
          toast.success(data.metadata.message);
        }
      })
      .catch((err) => {
        console.error("codes error", err);
        setdeleteLoading(false);
      });
  };

  const changeStatus2 = () => {
    setdeleteLoading(true);

    fetch(`${baseUrl}/admin/report-bugs-status/${selectedId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({
        status: statusValue,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.metadata.success) {
          getHistory(`${baseUrl}/admin/report-bugs`);
          setSelectedId(null);
          setdeleteLoading(false);
          setStatusModal(false);
          toast.success(data.metadata.message);
          setStatusModal2(false)
        }
      })
      .catch((err) => {
        console.error("codes error", err);
        setdeleteLoading(false);
      });
  };
console.log(statusValue,"what happening")
  return (
    <>
      <Card>
        <CardHeader title="Bugs Report"></CardHeader>

        <CardBody>
          {loading && (
            <div
              style={{
                width: "100%",
                height: "50vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <div class="spinner-border">
                {/* <span class="sr-only">Loading...</span> */}
              </div>
            </div>
          )}
          {!loading && rewardsList.length > 0 ? (
            <>
              <Table responsive>
                <thead>
                  <tr>
                    <th>Image</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>FIRST NAME</th>
                    <th>LAST NAME</th>
                    <th>EMAIL</th>
                    <th>STATUS</th>
                    <th>Public</th>
                  </tr>
                </thead>
                <tbody>
                  {rewardsList?.map((item) => (
                    <tr>
                      <td>
                        <Image
                          style={{ borderRadius: "50%" }}
                          width={40}
                          height={40}
                          src={item?.image?.original_url}
                        />
                      </td>
                      <td>{item?.name}</td>
                      <td>{item?.description}</td>
                      <td>{item?.user?.first_name}</td>
                      <td>{item?.user?.last_name}</td>
                      <td>{item?.user?.email}</td>
                      <td>
                        <Tag
                          onClick={() => {
                            setStatusValue(
                              item?.status == "Reported"
                                ? 1
                                : item?.status == "Being Investigated"
                                ? 2
                                : 3
                            );
                            setSelectedId(item.id);
                            setStatusModal2(true);
                          }}
                          style={{
                            cursor: "pointer",
                            width:item?.status=="Being Investigated" ? "" : "70px",
                            height: "25px",
                            textAlign: "center",
                          }}
                          color={getClassOrder(item?.status)}
                        >
                          {capitalizeFirstLetter(item?.status)}
                        </Tag>
                      </td>
                      <td>
                        <Switch
                          checked={item?.is_public}
                          onChange={() => {
                            setSelectedId(item.id);
                            setStatusModal(true);
                          }}
                        />
                      </td>
                          <td>
                                                                      <a className="btn btn-icon btn-light btn-sm">
                                                                          <span className="svg-icon svg-icon-md svg-icon-danger" onClick={() => handleShow2(item.id)}>
                                                                              <SVG
                                                                                  src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                                                                              ></SVG>
                                                                          </span>
                                                                      </a>
                                                                  </td>
                    </tr>
                  ))}
                  <tr></tr>
                </tbody>
              </Table>
              {/* <UsePagination links={links} onPaginate={onPaginate} /> */}
            </>
          ) : (
            ""
          )}
        </CardBody>
      </Card>
      <Modal
        show={statusModal}
        onHide={() => setStatusModal(false)}
        animation={false}
        size="md"
        // style={{ marginLeft: "140px" }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Status</Modal.Title>
        </Modal.Header>
        <Modal.Body className="row">
          <div className="col-md-12 ml-1">
            <h6 className="">Are you sure ? you want to change the status</h6>
          </div>
        </Modal.Body>

        <Modal.Footer>
          {deleteLoading ? (
            <Spinner animation="border" />
          ) : (
            <>
              <Button variant="secondary" onClick={() => setStatusModal(false)}>
                Close
              </Button>
              <Button variant="primary" onClick={changeStatus}>
                Change
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
      <Modal
                show={show2}
                onHide={handleClose2}
                animation={false}
                size="md"
                // style={{ marginLeft: "140px" }}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Bug Report</Modal.Title>
                </Modal.Header>
                <Modal.Body className="row">





                    <Form.Group className="mb-3 col-md-12" controlId="formBasicEmail">
                        <h3 className="text-center">Are you sure ? you want to delete it</h3>

                    </Form.Group>



                </Modal.Body>


                <Modal.Footer>
                    {
                        deleteLoading ?

                            <Spinner animation="border" />
                            :
                            <>
                                <Button variant="secondary" onClick={handleClose2}>
                                    Close
                                </Button>
                                <Button variant="danger" onClick={deleteCode}>
                                    Delete
                                </Button>
                            </>
                    }
                </Modal.Footer>
            </Modal>
      <Modal
        show={statusModal2}
        onHide={() => setStatusModal2(false)}
        animation={false}
        size="md"
        // style={{ marginLeft: "140px" }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Status</Modal.Title>
        </Modal.Header>
        <Modal.Body className="row">
          <div className="col-md-12 ml-1">
            <label>
              <b>Select Status</b>
            </label>
            <select
              onChange={(e) => setStatusValue(e.target.value)}
              value={statusValue}
              className="form-control"
              style={{ cursor: "pointer" }}
            >
              <option value={1}>Reported</option>
              <option value={2}>Being Investigated</option>
              <option value={3}>Resolved</option>
            </select>
          </div>
        </Modal.Body>

        <Modal.Footer>
          {deleteLoading ? (
            <Spinner animation="border" />
          ) : (
            <>
              <Button
                variant="secondary"
                onClick={() => setStatusModal2(false)}
              >
                Close
              </Button>
              <Button variant="primary" onClick={changeStatus2}>
                Change
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BugsReports;
